import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { formatCurrency } from "../../services/formatCurrency";
import "../../styles/profil.css";
import "../../styles/all.css";
import "../../styles/modifyProduct.css";
import ModifyProductImg from "./modifyProductImg";
import Alert from "react-bootstrap/Alert";

const initialValues = {
  name: "",
  category: "",
  price: 1,
  oldPrice: 0,
  description: "",
  quentity: 1,
  techDescription: [],
};

const ProductSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "trop petit!")
    .max(200, "trop long!")
    .required("Ce champ est obligatoire"),
  category: Yup.string()
    .required("Ce champ est obligatoire")
    .oneOf(
      ["Accessoires", "Jouets", "Nourritures"],
      "La catégorie doit être l'une des valeurs suivantes: Accessoires, Jouets, Nourritures"
    ),
  price: Yup.number()
    .integer("Le prix doit être un nombre entier")
    .min(0, "Le prix en euro doit être supérieur ou égal à 0")
    .required("Le prix est obligatoire")
    .typeError("Saisissez le prix"),
  oldPrice: Yup.number()
    .integer("Le prix doit être un nombre entier")
    .min(0, "Le prix en euro doit être supérieur ou égal à 0")
    .typeError("Saisissez le prix"),
  description: Yup.string()
    .min(2, "trop petit!")
    .max(2000, "trop long!")
    .required("Ce champ est obligatoire"),
  quentity: Yup.number()
    .positive("La quentité doit être un nombre positif")
    .integer("La quentité doit être un nombre entier")
    .min(0, "La quantité ne peut être négative")
    .required("Ce champ est obligatoire")
    .typeError("Saisissez la quantité"),
});

const ModifyProduct = ({ item }) => {
  const [msg, setMsg] = useState("");
  const [showMsg, setShowMsg] = useState("");

  const paramsId = useParams();

  const [formValues, setFormValues] = useState([{ titre: "", valeur: "" }]);

  const addFormFieldsDescription = () => {
    setFormValues([...formValues, { titre: "", valeur: "" }]);
  };

  const removeFormFieldsDescription = (i) => {
    const newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const handleChangeValues = (e, index) => {
    const { name, value } = e.target;
    const newFormValues = [...formValues];
    newFormValues[index][name] = value;
    setFormValues(newFormValues);
  };

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    initialValues.techDescription.push(...formValues);
    const token = localStorage.getItem("jwt");

    if (formValues.length >= 3) {
      axios({
        method: "PUT",
        url: `${process.env.REACT_APP_API_URL}/stuff/${paramsId.id}`,
        data: {
          name: values.name,
          category: values.category,
          price: values.price,
          oldPrice: values.oldPrice,
          description: values.description,
          quentity: values.quentity,
          techDescription: [...values.techDescription],
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: paramsId.id,
      })
        .then((response) => {
          setSubmitting(false);
          resetForm();
          setMsg(response.data.message);
          window.location.reload();
        })
        .catch((error) => {
          setSubmitting(false);
          resetForm();
          setFormValues([{ titre: "", valeur: "" }]);
          initialValues.images = [];
          initialValues.techDescription = [];
          setMsg(error.data.message);
          console.log(error);
        });
    } else {
      setShowMsg(
        "Vous devez ajouter au minimum 3 images produits et 3 descriptions techniques !"
      );
    }
  };

  const setInitialValues = async () => {
    item.techDescription.forEach((obj) => {
      delete obj["_id"];
    });
    setFormValues(item.techDescription);
    initialValues.name = item.name;
    initialValues.category = item.category;
    initialValues.price = item.price;
    initialValues.description = item.description;
    initialValues.quentity = item.quentity;
    item.oldPrice
      ? (initialValues.oldPrice = item.oldPrice)
      : (initialValues.oldPrice = 0);
  };
  useEffect(() => {
    setInitialValues();
  }, []);

  return (
    <div className="bgcolorffffff ">
      <div className="addItemsContainer p-xl-5">
        <Formik
          initialValues={initialValues}
          validationSchema={ProductSchema}
          onSubmit={onSubmit}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              className="form-container-formik d-flex flex-column gap-3"
              onSubmit={handleSubmit}
            >
              <div className="">
                <h5 className="text-center font-size-1_6">
                  Formulaire de modification produit
                </h5>
              </div>
              <Form.Group>
                <Form.Label>Nom du Produit</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  isValid={touched.name && !errors.name}
                  isInvalid={!!errors.name}
                  onBlur={handleBlur}
                  required
                />
                <ErrorMessage
                  component="span"
                  name="name"
                  className="text-danger"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Catégorie du produit</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  name="category"
                  value={values.category}
                  onChange={handleChange}
                  isValid={touched.category && !errors.category}
                  isInvalid={!!errors.category}
                  onBlur={handleBlur}
                  required
                >
                  <option>Sélectionner la catégorie du produit</option>
                  <option value="Accessoires">Accessoires</option>
                  <option value="Jouets">Jouets</option>
                  <option value="Nourritures">Nourritures</option>
                </Form.Select>
                <ErrorMessage
                  component="span"
                  name="category"
                  className="text-danger"
                />
              </Form.Group>

              <div>
                <Form.Label>Prix du Produit</Form.Label>
                <InputGroup className="position-relative">
                  <InputGroup.Text>Prix</InputGroup.Text>
                  <Form.Control
                    className="inputPrice"
                    type="number"
                    name="price"
                    value={values.price}
                    onChange={handleChange}
                    isValid={touched.price && !errors.price}
                    isInvalid={!!errors.price}
                    onBlur={handleBlur}
                    required
                  />
                  <InputGroup.Text>
                    {formatCurrency(values.price)}
                  </InputGroup.Text>
                </InputGroup>

                <ErrorMessage
                  component="span"
                  name="price"
                  className="text-danger"
                />
              </div>

              <div>
                <Form.Label>Prix du Produit avant promotion</Form.Label>
                <br />
                <Form.Text>
                  La valeur indiquée ci-dessous indique le prix du produit avant
                  la promotion. <br /> Si la valeur est à 0, l'ancien prix ne
                  sera pas affiché.
                </Form.Text>
                <InputGroup className="position-relative">
                  <InputGroup.Text>Prix</InputGroup.Text>
                  <Form.Control
                    className="inputPrice"
                    type="number"
                    name="oldPrice"
                    value={values.oldPrice}
                    onChange={handleChange}
                    isValid={touched.oldPrice && !errors.oldPrice}
                    isInvalid={!!errors.oldPrice}
                    onBlur={handleBlur}
                    required
                  />
                  <InputGroup.Text className="discount">
                    {formatCurrency(values.oldPrice)}
                  </InputGroup.Text>
                </InputGroup>
                <ErrorMessage
                  component="span"
                  name="oldPrice"
                  className="text-danger"
                />
              </div>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Déscription du produit</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  isValid={touched.description && !errors.description}
                  isInvalid={!!errors.description}
                  onBlur={handleBlur}
                  as="textarea"
                  required
                  rows={5}
                />
                <ErrorMessage
                  component="span"
                  name="description"
                  className="text-danger"
                />
              </Form.Group>
              <Form.Group
                controlId="validationFormik101"
                className="position-relative"
              >
                <Form.Label>Quantité du produit</Form.Label>
                <Form.Control
                  type="number"
                  name="quentity"
                  value={values.quentity}
                  onChange={handleChange}
                  isValid={touched.quentity && !errors.quentity}
                  isInvalid={!!errors.quentity}
                  onBlur={handleBlur}
                  min="0"
                  required
                />
                <ErrorMessage
                  component="span"
                  name="quentity"
                  className="text-danger"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Description technique</Form.Label>
                {formValues.map((element, i) => {
                  return (
                    <div key={i}>
                      <div className="d-flex justify-content-center gap-3">
                        <Form.Control
                          type="text"
                          name="titre"
                          onChange={(e) => handleChangeValues(e, i)}
                          value={element.titre}
                          onBlur={handleBlur}
                          required
                        />
                        <Form.Control
                          type="text"
                          name="valeur"
                          onChange={(e) => handleChangeValues(e, i)}
                          value={element.valeur}
                          onBlur={handleBlur}
                          required
                        />
                        {i ? (
                          <Button
                            onClick={() => removeFormFieldsDescription(i)}
                          >
                            Suprimer ligne
                          </Button>
                        ) : null}
                      </div>
                    </div>
                  );
                })}

                {formValues.length < 3 && (
                  <div>
                    <span className="text-danger">
                      Minimum 3 descriptions techniques requise
                    </span>
                  </div>
                )}

                <div>
                  <Button
                    type="button"
                    onClick={() => addFormFieldsDescription()}
                  >
                    Ajouter une ligne
                  </Button>
                </div>
              </Form.Group>
              <div className="d-flex justify-center">
                <span className="text-danger text-center">{showMsg}</span>
              </div>
              {msg && (
                <Alert className="text-center" variant="success">
                  {msg}
                </Alert>
              )}
              <div className="d-flex justify-content-center m-5">
                <Button
                  className="borderRadius_15px"
                  variant="primary"
                  type="submit"
                >
                  Valider
                </Button>
              </div>
            </Form>
          )}
        </Formik>

        <ModifyProductImg item={item} />
      </div>
    </div>
  );
};

export default ModifyProduct;
